import axios from 'axios';
import {
    getRequest,
    getSuccess,
    getFailed,
    getError
} from './noticeSlice';

export const getAllNotices = (id, address) => async (dispatch) => {
    dispatch(getRequest());

    try {
        const result = await axios.get(`${process.env.REACT_APP_BASE_URL}/${address}List/${id}`);
        if (result.data.message) {
            dispatch(getFailed(result.data.message));
        } else {
            dispatch(getSuccess(result.data));
        }
    } catch (error) {
        dispatch(getError(error));
    }
}
export const addStuff = (fields, address) => async (dispatch) => {
    dispatch( getRequest()); // Or your specific action for starting the request
    try {
        const res = await axios.post(`${process.env.REACT_APP_BASE_URL}/${address}Create`, fields);
        dispatch({ type: 'ADD_SUCCESS', payload: res.data });
    } catch (error) {
        dispatch({ type: 'ADD_FAILURE', payload: error.response?.data?.message || error.message });
    }
};